/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_AgainInputs */

const en_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try Again`)
};

const es_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

const fr_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const ja_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const zh_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const ar_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول مرة أخرى`)
};

const id_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba Lagi`)
};

const it_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const ru_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать снова`)
};

const pt_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar Novamente`)
};

const ko_try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

/**
* | output |
* | --- |
* | "Try Again" |
*
* @param {Try_AgainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const try_again = /** @type {((inputs?: Try_AgainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_AgainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_try_again(inputs)
	if (locale === "es") return es_try_again(inputs)
	if (locale === "fr") return fr_try_again(inputs)
	if (locale === "de") return de_try_again(inputs)
	if (locale === "ja") return ja_try_again(inputs)
	if (locale === "zh") return zh_try_again(inputs)
	if (locale === "ar") return ar_try_again(inputs)
	if (locale === "id") return id_try_again(inputs)
	if (locale === "it") return it_try_again(inputs)
	if (locale === "ru") return ru_try_again(inputs)
	if (locale === "pt") return pt_try_again(inputs)
	return ko_try_again(inputs)
});